import { render, staticRenderFns } from "./Track.vue?vue&type=template&id=5838670c&"
import script from "./Track.vue?vue&type=script&lang=js&"
export * from "./Track.vue?vue&type=script&lang=js&"
import style0 from "./Track.vue?vue&type=style&index=0&id=5838670c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports